export default {
  getBudgetDocuments: (state) => state.budgetDocuments,
};
